import { api } from "@/lib/api";

const b64ToUint8 = (b64) => {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const s = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(s);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    // Route "open URL" messages from SW into React Router
    navigator.serviceWorker.addEventListener("message", (e) => {
      if (e.data && e.data.type === "OPEN_URL" && e.data.url) {
        if (window.location.pathname !== e.data.url) {
          window.history.pushState({}, "", e.data.url);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
      }
    });
    return reg;
  } catch (e) {
    console.warn("SW registration failed", e);
    return null;
  }
}

export async function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function currentPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function subscribeToPush() {
  if (!(await pushSupported())) throw new Error("Push not supported on this device/browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications permission denied");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-key");
  if (!data.public_key) throw new Error("Push not configured on server");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8(data.public_key),
    });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    } catch (_) {}
    await sub.unsubscribe();
  }
}
